import * as React from 'react';

import * as styles from './styles.css';

export const RealtorInfoMobileSection: React.FC<React.PropsWithChildren<unknown>> = props => {
  return <div className={styles['section']}>{props.children}</div>;
};

RealtorInfoMobileSection.displayName = 'RealtorInfoMobileWrapper';
